// extracted by mini-css-extract-plugin
export default {"box":"cancellationDetailPage_box__axIgW","box__order__detail":"cancellationDetailPage_box__order__detail__FH8kW"};